import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ContactPreview = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#2A2A2A]">
      <div className="container-custom">
        <motion.h2
          className="text-3xl sm:text-4xl font-light text-[#F5F5F5] text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {t('home.contactPreview.title')}
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            className="text-[#CCCCCC] text-base leading-relaxed"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="mb-6">{t('home.contactPreview.p1')}</p>
            <p className="mb-10">{t('home.contactPreview.p2')}</p>

            <div className="flex items-center mb-6">
              <Mail size={20} className="mr-4 text-[#C8102E]" />
              <div>
                <h3 className="font-medium text-[#F5F5F5]">{t('contact.emailTitle')}</h3>
                <p>mad73.arquitectos@gmail.com</p>
              </div>
            </div>

            <Link
              to="/contact"
              className="inline-flex items-center text-[#F5F5F5] hover:text-[#C8102E] transition-colors group"
            >
              {t('home.contactPreview.contactPage')}
              <ArrowRight size={18} className="ml-2 transition-transform group-hover:translate-x-1" />
            </Link>
          </motion.div>

          <motion.div
            className="bg-[#222222] p-6 rounded shadow-md flex items-center justify-center"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <img
              src="/images/3.2.webp"
              alt={t('home.contactPreview.contactVisualAlt')}
              className="w-full max-h-[400px] object-cover rounded"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactPreview;
